export default class SoundController {
	constructor(scene) {
		this.scene = scene;
		this._musicOn = true;
		this._soundOn = true;
		this.music = null;
		this.sounds = [];
	}

	soundOn(soundOn) {
		this._soundOn = soundOn;
		this._refreshSoundSources();
	}

	musicOn(musicOn) {
		this._musicOn = musicOn;
		this._refreshSoundSources();
	}

	playClip(clip, loopSound) {
		if (this.scene[clip] !== undefined && this._soundOn) {
			this.scene[clip].play({ loop: loopSound });
			this.sounds.push(clip);
		}
	}

	stopClip(clip) {
		if (this.scene[clip] !== undefined) {
			this.scene[clip].stop();
		}
	}

	playMusic(clip) {
		if (this.music !== null && this.music !== clip) {
			this.music.stop();
		}
		this.music = this.scene[clip];
		if (!this._musicOn) return;
		this.music.play({ loop: true });
	}

	stopMusic() {
		if (this.music !== null) {
			this.music.stop();
		}
	}

	stopSounds() {
		console.log('this.sounds.length: ' + this.sounds.length);
		this.sounds.forEach(s => {
			console.log('sound: ' + s);
			this.scene[s].stop();
		});
	}

	_refreshSoundSources() {
		if (!this._musicOn) {
			this.stopMusic();
		} else {
			if (this.music !== null) {
				this.music.play();
			}
		}

		if (!this._soundOn) {
			this.stopSounds();
		}
	}

	stopAll() {
		this.scene.sound.stopAll();
	}
}
